import request from '@/utils/request'

// 查询列表
export function apiAttendanceModeList(query) {
  return request({
    url: '/bom/attendanceMode/list',
    method: 'get',
    params: query
  })
}

// 修改
export function apiAttendanceModeUpdate (data) {
  return request({
    url: '/bom/attendanceMode/save',
    method: 'post',
    data: data
  })
}

// 删除
export function apiAttendanceModeDel (codes) {
  return request({
    url: '/bom/attendanceMode/remove',
    method: 'post',
    data: codes
  })
}
